const KEY = "agroterra_offline";

export function listOffline() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

export function saveOffline(item) {
  const items = listOffline().filter((x) => x.id !== item.id);
  items.unshift({ ...item, saved_at: new Date().toISOString() });
  localStorage.setItem(KEY, JSON.stringify(items.slice(0, 50)));
  return items;
}

export function removeOffline(id) {
  const items = listOffline().filter((x) => x.id !== id);
  localStorage.setItem(KEY, JSON.stringify(items));
  return items;
}

export function isSavedOffline(id) {
  return listOffline().some((x) => x.id === id);
}
